import React from 'react';
import type { PublishChoice } from '../domain/listings';
import ScheduleField from './ScheduleField';

const PUBLISH_CHOICES: { value: PublishChoice; label: string }[] = [
  { value: 'now', label: 'Publish now' },
  { value: 'draft', label: 'Save as draft' },
  { value: 'scheduled', label: 'Schedule' },
];

/** Publish now, keep as a draft, or schedule for a time — for a new listing or a draft. */
export default function PublishChoiceField({
  publish,
  onPublishChange,
  publishAt,
  onPublishAtChange,
}: {
  publish: PublishChoice;
  onPublishChange: (choice: PublishChoice) => void;
  publishAt: string | null;
  onPublishAtChange: (at: string | null) => void;
}) {
  return (
    <fieldset className="space-y-3">
      <legend className="mb-2 text-sm font-medium">When</legend>
      {PUBLISH_CHOICES.map((choice) => (
        <label key={choice.value} className="flex cursor-pointer items-center gap-3">
          <input
            type="radio"
            name="publish"
            value={choice.value}
            checked={publish === choice.value}
            onChange={() => onPublishChange(choice.value)}
            className="size-4 accent-primary"
          />
          <span>{choice.label}</span>
        </label>
      ))}
      {publish === 'scheduled' && (
        <ScheduleField id="publish_at" value={publishAt} onChange={onPublishAtChange} />
      )}
      {publish === 'draft' && (
        <p className="text-sm text-muted-foreground">
          Only you can see a draft until you publish it.
        </p>
      )}
    </fieldset>
  );
}
